import React from 'react';
const blockName = 'match-result-component';
export default function MatchWithoutResult(){
  return (
    <div className={ `${ blockName }__container` }>
      <div className={ `${ blockName }__vs` }>vs.</div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/components/matchWithoutResult.js